import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { getAvailabilityTemplateByStaffID, getMasterData, saveAvailabilityTemplate } from '../actions/UserActions';
import { renderCheckBox, renderDateField, renderTimePickerForStaffAvailbility } from '../../../components/reduxFields';

import _ from 'lodash';
import { CommonButton } from '../../../../src/components/buttons';

import { connect } from 'react-redux';
import moment from 'moment';
import React from 'react';
import history from '../../../../src/history';
import validate from './validate';


class AvailabilityTemplate extends React.Component {
  constructor(props) {
    super(props);
    let week = [];
    let newWeek = [];
    let availabilityData = new Array(1).fill({ availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null });
    let unavailabilityData = new Array(1).fill({ unavailabilityDate: null,
      unavailabilityStartTime: null,
      unavailabilityEndTime: null });

    for (let i = 0; i < 7; i++) {
      newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
    }
    week.push(newWeek);
    this.state = {
      week: week,
      availabilityData: availabilityData,
      unavailabilityData: unavailabilityData,
      staffID: '',
      master_data: [],
      prevStaffID: '',
      applyToAll: false
    };
    this.onUnavailabilityDateChange = this.onUnavailabilityDateChange.bind(this);
    this.onAvailabilityDateChange = this.onAvailabilityDateChange.bind(this);
    this.renderAvailabilityTemplate = this.renderAvailabilityTemplate.bind(this);
    this.renderUnavailabilityTemplate = this.renderUnavailabilityTemplate.bind(this);
  };

  componentWillMount() {
    // this.props.getMasterData('staffavailability,MASTERWEEKDAYS');
    // this.props.getOfficeHours(this.props.staffLocations);
    if (this.props.staffId) {
      this.props.getAvailabilityTemplateByStaffID(this.props.staffId);
      this.setState({
        staffID: this.props.staffId,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.staffId && nextProps.staffId !== this.props.staffId) {
      this.props.getAvailabilityTemplateByStaffID(nextProps.staffId);
      this.setState({
        staffID: nextProps.staffId,
      });
    }
    if (nextProps.staffAvailabilityData && this.props.staffAvailabilityData !== nextProps.staffAvailabilityData) {
      ;
      if (nextProps.initialValues && this.props.initialValues !== nextProps.initialValues) {
        this.setState({
          week: nextProps.initialValues.week,
          availabilityData: nextProps.initialValues.availabilityData,
          unavailabilityData: nextProps.initialValues.unavailabilityData,
          isDay: nextProps.initialValues.isDay,
        });
      }
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
      });
    }

    if (nextProps.officeHours && nextProps.officeHours !== this.props.officeHours) {

    }

  };

  onTimeChange(input, value, index) {
    // input.onChange(moment(value).format());
    let name = input.name;
    let weekData = this.state.week;
    let row = parseInt(name.slice(5, 6), 10);
    let column = parseInt(name.slice(8, 9), 10);
    let fieldName = name.slice(11);
    let dayIndexArray = this.props.master_data.masterWeekDays;
    _.update(weekData, `[${row}][${column}].DayId`, function(n) {
      return dayIndexArray[index].id;
    });
    _.update(weekData, `[${row}][${column}].${fieldName}`, function(n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });
    this.setState({
      week: weekData,
    });
  }

  handleWeekData = (index) => {
    let name = `week[0][${index}].StartTime`;
    let weekData = this.state.week;
    let row = parseInt(name.slice(5, 6), 10);
    let column = parseInt(name.slice(8, 9), 10);
    // let fieldName = name.slice(11); // This is not needed
    let dayIndexArray = this.props.master_data.masterWeekDays;
    if((this.state.applyToAll === true && index !== 1)) {

      _.update(weekData, `[${row}][${column}].DayId`, function(n) {
        return dayIndexArray[index].id;
      });

      _.update(weekData, `[${row}][${column}].StartTime`, function(n) {
        return weekData[0][1].StartTime
      });

      _.update(weekData, `[${row}][${column}].EndTime`, function(n) {
        return weekData[0][1].EndTime
      });

      this.setState({
        week: weekData, 
      });
    } else {
      _.update(weekData, `[${row}][${column}].DayId`, function(n) {
        return dayIndexArray[index].id;
      });

      _.update(weekData, `[${row}][${column}].StartTime`, function(n) {
        return;
      });

      _.update(weekData, `[${row}][${column}].EndTime`, function(n) {
        return;
      });

      this.setState({
        week: weekData, 
      });
    }
  }

  onAvailabilityDateChange = (input, value) => {
    let row = parseInt(input.name.slice(17, 18), 10);
    let name = input.name.slice(20);
    let availabilityData = this.state.availabilityData;

    _.update(availabilityData, `[${row}].${name}`, function(n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    if (name === 'availabilityDate') {
      input.onChange(moment(value).format());
    }

    this.setState({ availabilityData: availabilityData });
  }

  onUnavailabilityDateChange = (input, value) => {
    let row = parseInt(input.name.slice(19, 21), 10);
    let name = input.name.slice(22);
    let unavailabilityData1 = this.state.unavailabilityData;

    _.update(unavailabilityData1, `[${row}].${name}`, function(n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });
    if (name === 'unavailabilityDate') {
      input.onChange(moment(value).format());
    }
    this.setState({ unavailabilityData: unavailabilityData1 });
  }
  handleSaveAndSubmit = (formData) => {
    this.onSubmit(formData);
    history.push('/users');
  }
  onSubmit = (formData) => {
    // console.log(formData);
    let formData1 = [];
    formData1.weekData = [];
    formData1.availabilityData = [];
    formData1.unavailabilityData = [];
    let week = this.state.week;
    this.state.week.map((obj, rowIndex) => {
      let x = Object.values(obj);
      if (x.length > 0) {
        x.forEach((value, colIndex) => {
          if (this.props.isDay && this.props.isDay[colIndex] === false) {
            _.update(week, `[${rowIndex}][${colIndex}].id`, function(n) {
              return value.id;
            });
            _.update(week, `[${rowIndex}][${colIndex}].DayId`, function(n) {
              return null;
            });
            _.update(week, `[${rowIndex}][${colIndex}].StartTime`, function(n) {
              return null;
            });
            _.update(week, `[${rowIndex}][${colIndex}].EndTime`, function(n) {
              return null;
            });
          }
          this.setState({
            week: week,
          });
        });
      };
      return true;
    });
    this.state.week.map((obj, rowIndex) => {
      let x = Object.values(obj);
      if (x.length > 0) {
        x.forEach((value, colIndex) => {
          if (value.EndTime && value.StartTime && value.DayId) {
            if (formData1.weekData.indexOf(value) === -1) {
              formData1.weekData.push(value);
            }
          }
        });
      }
      return formData1;
    });
    this.state.availabilityData.map((obj, index) => {
      if (obj.availabilityDate && obj.availabilityStartTime && obj.availabilityEndTime) {
        if (formData1.availabilityData.indexOf(obj) === -1) {
          formData1.availabilityData.push(obj);
        }

      }
      return formData1;
    });
    this.state.unavailabilityData.map((obj, index) => {
      if (obj.unavailabilityDate !== null && obj.unavailabilityStartTime !== null && obj.unavailabilityEndTime !== null) {
        if (formData1.unavailabilityData.indexOf(obj) === -1) {
          formData1.unavailabilityData.push(obj);
        }
      }
      return formData1;
    });

    let weekDataTypeID = null;
    let availabilityDataTypeID = null;
    let unavailabilityDataTypeID = null;
    if (this.props.master_data && this.props.master_data.staffAvailability && this.props.master_data.staffAvailability.length > 0) {
      this.props.master_data.staffAvailability.map((obj, index) => {
        if (obj.globalCodeName.toUpperCase() === 'weekDay'.toUpperCase()) {
          weekDataTypeID = obj.id;
        }
        if (obj.globalCodeName.toUpperCase() === 'available'.toUpperCase()) {
          availabilityDataTypeID = obj.id;
        }
        if (obj.globalCodeName.toUpperCase() === 'unavailable'.toUpperCase()) {
          unavailabilityDataTypeID = obj.id;
        }
        return { weekDataTypeID, availabilityDataTypeID, unavailabilityDataTypeID };
      });
    }
    formData1.weekDataTypeID = weekDataTypeID;
    formData1.unavailabilityDataTypeID = unavailabilityDataTypeID;
    formData1.availabilityDataTypeID = availabilityDataTypeID;

    formData1.StaffID = this.props.staffId;

    let filteredFormData = this.filterSubmittedData(formData1);
    // console.log(JSON.stringify(filteredFormData));
    this.props.saveAvailabilityTemplate(filteredFormData);
  }


  // function to get insert/update staffAvailability Data with IsDeleted = true/false
  filterSubmittedData(formValues) {

    let weekData = formValues.weekData || [],
      availabilityData = formValues.availabilityData || [],
      unavailabilityData = formValues.unavailabilityData || [];

    // add or update case for DaysAvailability
    let DaysAvailability = this.props.staffAvailabilityData && this.props.staffAvailabilityData.days ? this.props.staffAvailabilityData.days : [];
    DaysAvailability = DaysAvailability.map((obj) => {
      return {
        'Id': obj.id,
        'DayId': obj.dayId,
        'StartTime': obj.startTime,
        'EndTime': obj.endTime,
        'StaffAvailabilityTypeID': obj.staffAvailabilityTypeID,
        'IsDeleted': true,
      };
    });
    weekData.forEach((obj) => {
      // update case ------
      let dayData = DaysAvailability.find((Obj) => Obj.Id === obj.id && Obj.IsDeleted);
      if (dayData) {
        let index = DaysAvailability.indexOf(dayData);
        DaysAvailability[index] = {
          ...dayData,
          'DayId': obj.DayId,
          'StartTime': obj.StartTime,
          'EndTime': obj.EndTime,
          IsDeleted: false };
      } else {
        DaysAvailability.push({
          'Id': 0,
          'DayId': obj.DayId,
          'StartTime': obj.StartTime,
          'EndTime': obj.EndTime,
          'StaffAvailabilityTypeID': formValues.weekDataTypeID,
          'IsDeleted': false,
        });
      }
    });

    // add or update case for availabilityDates
    let availabilityDates = [];
    if (this.props.staffAvailabilityData && this.props.staffAvailabilityData.available) {
      availabilityDates = this.props.staffAvailabilityData.available;
    }
    availabilityDates = availabilityDates.map((obj) => {
      return {
        'Id': obj.id,
        'Date': obj.date,
        'StartTime': obj.startTime,
        'EndTime': obj.endTime,
        'StaffAvailabilityTypeID': obj.staffAvailabilityTypeID,
        'IsDeleted': true,
      };
    });
    availabilityData.forEach((obj) => {
      // update case ------
      let dayData = availabilityDates.find((Obj) => Obj.Id === obj.id && Obj.IsDeleted);
      if (dayData) {
        let index = availabilityDates.indexOf(dayData);
        availabilityDates[index] = {
          ...dayData,
          'Date': obj.availabilityDate,
          'StartTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityEndTime).format('HH:mm'),
          IsDeleted: false };
      } else {
        availabilityDates.push({
          'Id': 0,
          'Date': obj.availabilityDate,
          'StartTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityEndTime).format('HH:mm'),
          'StaffAvailabilityTypeID': formValues.availabilityDataTypeID,
          'IsDeleted': false,
        });
      }
    });

    // add or update case for unAvailabilityDates
    let unAvailabilityDates = [];
    if (this.props.staffAvailabilityData && this.props.staffAvailabilityData.unavailable) {
      unAvailabilityDates = this.props.staffAvailabilityData.unavailable;
    }
    unAvailabilityDates = unAvailabilityDates.map((obj) => {
      return {
        'Id': obj.id,
        'Date': obj.date,
        'StartTime': obj.startTime,
        'EndTime': obj.endTime,
        'StaffAvailabilityTypeID': obj.staffAvailabilityTypeID,
        'IsDeleted': true,
      };
    });
    unavailabilityData.forEach((obj) => {
      // update case ------
      let dayData = unAvailabilityDates.find((Obj) => Obj.Id === obj.id && Obj.IsDeleted);
      if (dayData) {
        let index = unAvailabilityDates.indexOf(dayData);
        unAvailabilityDates[index] = {
          ...dayData,
          'Date': obj.unavailabilityDate,
          'StartTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityEndTime).format('HH:mm'),
          IsDeleted: false };
      } else {
        unAvailabilityDates.push({
          'Id': 0,
          'Date': obj.unavailabilityDate,
          'StartTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityEndTime).format('HH:mm'),
          'StaffAvailabilityTypeID': formValues.unavailabilityDataTypeID,
          'IsDeleted': false,
        });
      }
    });
    let filteredFormData = {
      StaffID: formValues.StaffID,
      Days: DaysAvailability,
      Available: availabilityDates,
      Unavailable: unAvailabilityDates,
    };
    return filteredFormData;
  }


  addWeekRow = () => {};
  removeWeekRow = (i) => {};
  addAvailabilityRow = () => {};
  removeAvailabilityRow = (i) => {};
  addUnavailabilityRow = () => {};
  removeUnavailabilityRow = (i) => {};
  renderWeekTemplate = ({ fields }) => {

    this.removeWeekRow = (i, e) => {
      fields.remove(i);
      let week = this.state.week;
      week.splice(i, 1);
      this.setState({
        week: week,
      });

    };
    this.addWeekRow = (e) => {
      fields.push({});
      let week = this.state.week;
      let newWeek = [];
      for (let i = 0; i < 7; i++) {
        newWeek.push({ StartTime: null, EndTime: null, DayId: null });
      }
      week.push(newWeek);
      this.setState({
        week: week,
      });
    };
    return (
      <div>
        {fields.map((week, index) =>
          <div key = {index}>
            <ul>
              {this.renderWeekDays(week, index)}
              <div>
                { (fields.length - 1) === index ?
                  <div>
                    {fields.length > 1 ?
                      (<button className="removeitem"
                        onClick={(e) => this.removeWeekRow(index, e)} type="button" title="Remove Row">
                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                      </button>)
                      : ''}
                    <button className="additem" onClick={this.addWeekRow} type="button" title="Add row">
                      <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                    </button>
                  </div>
                  :
                  <div>
                    <button className="removeitem"
                      onClick={(e) => this.removeWeekRow(index, e)} type="button" title="Remove Row">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  </div>
                }
              </div>
            </ul>
          </div>
        )
        }
      </div>
    );
  };
    renderAvailabilityTemplate = ({ fields }) => {
      this.removeAvailabilityRow = (i, e) => {
        fields.remove(i);
        let availabilityData = this.state.availabilityData;
        availabilityData.splice(i, 1);
        this.setState({
          availabilityData: availabilityData,
        });
        this.props.dispatch(change('AvailabilityTemplateForm', availabilityData[i], null));
      };

      this.addAvailabilityRow = (e) => {
        fields.push({});
        let availabilityData = this.state.availabilityData;
        let newData = { availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null };
        availabilityData.splice((this.state.availabilityData.length), 1, newData);
        newData = {};
        this.setState({
          availabilityData: availabilityData,
        });

      };
      return (
        <div>
          { fields.map((availabilityData, index) => {
            return (
              <div className="availabletime" key = {index}>
                <div className="pdr-40 parent_div">

                  {this.renderAvailabilityData(availabilityData, index)}

                  <div>
                    { (fields.length - 1) === index ?
                      <div>
                        {fields.length > 1 ?
                          (<button className="removeitem"
                            onClick={(e) => this.removeAvailabilityRow(index, e)} type="button" title="Remove Row">
                            <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                          </button>)
                          : ''}
                        <button className="additem" onClick={this.addAvailabilityRow} type="button" title="Add row">
                          <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                        </button>
                      </div>
                      :
                      <div>
                        <button className="removeitem"
                          onClick={(e) => this.removeAvailabilityRow(index, e)} type="button" title="Remove Row">
                          <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>);
          }
          )}
        </div>
      );
    };
    renderAvailabilityData = (availabilityData, index) => {
      return (
        <div>

          <div key = {index} className ="row">
            <div className="col-sm-4">
              <Field
                name= {`${availabilityData}.availabilityDate`}
                placeholder="Availability Date"
                component={renderDateField}
                openToYearSelection = {true}
                selected={ this.props.availabilityData && this.props.availabilityData[index] && this.props.availabilityData[index].availabilityDate ? this.props.availabilityData[index].availabilityDate : null}
                onDateChange={(input, value) =>
                  this.onAvailabilityDateChange(input, value)
                }
                locale="en-US"
                fullWidth={true}
              />
            </div>
            <div className="col-sm-4">
              <Field
                name={`${availabilityData}.availabilityStartTime`}
                placeholder="Start Time"
                component={renderTimePickerForStaffAvailbility}
                disabled = {this.props.availabilityData && this.props.availabilityData[index] && this.props.availabilityData[index].availabilityDate ? false : true}
                selected={this.state.availabilityData && this.state.availabilityData[index] && this.state.availabilityData[index].availabilityStartTime ? this.state.availabilityData[index].availabilityStartTime : null}
                onDateChange={(input, value) =>
                  this.onAvailabilityDateChange(input, value)
                }
                fullWidth={true}
              />
            </div>
            <div className="col-sm-4">
              <Field
                name={`${availabilityData}.availabilityEndTime`}
                placeholder="End Time"
                component={renderTimePickerForStaffAvailbility}
                disabled = {this.props.availabilityData && this.props.availabilityData[index] && this.props.availabilityData[index].availabilityDate ? false : true}
                selected={this.state.availabilityData && this.state.availabilityData[index] && this.state.availabilityData[index].availabilityEndTime ? this.state.availabilityData[index].availabilityEndTime : null}
                onDateChange={(input, value) => this.onAvailabilityDateChange(input, value)}
                fullWidth={true}
              />
            </div>
          </div>
        </div>);
    }

  renderUnavailabilityTemplate = ({ fields }) => {
    this.removeUnavailabilityRow = (i, e) => {
      fields.remove(i);
      let unavailabilityData = this.state.unavailabilityData;
      unavailabilityData.splice(i, 1);
      this.setState({
        unavailabilityData: unavailabilityData,
      });
      this.props.dispatch(change('AvailabilityTemplateForm', unavailabilityData[i], null));
    };

    this.addUnavailabilityRow = (e) => {

      fields.push({});
      let unavailabilityData = this.state.unavailabilityData;
      let newData = {};
      newData = { unavailabilityDate: null, unavailabilityStartTime: null, unavailabilityEndTime: null };
      unavailabilityData.push(newData);
      this.setState({
        unavailabilityData: unavailabilityData,
      });

    };
    return (
      <div>

        { fields.map((unavailabilityData, index) => {
          return (
            <div className="unavailabletime" key = {index}>
              <div className="pdr-40 parent_div">

                {this.renderUnavailabilityData(unavailabilityData, index)}

                <div>
                  { (fields.length - 1) === index ?
                    <div>
                      {fields.length > 1 ?
                        (<button className="removeitem"
                          onClick={(e) => this.removeUnavailabilityRow(index, e)} type="button" title="Remove Row">
                          <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                        </button>)
                        : ''}
                      <button className="additem" onClick={this.addUnavailabilityRow} type="button" title="Add row">
                        <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                      </button>
                    </div>
                    :
                    <div>
                      <button className="removeitem"
                        onClick={(e) => this.removeUnavailabilityRow(index, e)} type="button" title="Remove Row">
                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                      </button>
                    </div>
                  }
                </div>

              </div>
            </div>);
        }
        )}
      </div>
    );
  };
  renderUnavailabilityData = (unavailabilityData, index) => {

    return (<div key = {index} className ="row">
      <div className="col-sm-4">
        <Field
          name={`${unavailabilityData}.unavailabilityDate`}
          placeholder="Unavailability Date"
          component={renderDateField}
          openToYearSelection = {true}
          selected={ this.props.unavailabilityData && this.props.unavailabilityData[index] && this.props.unavailabilityData[index].unavailabilityDate ? this.props.unavailabilityData[index].unavailabilityDate : null}
          onDateChange={(input, value) => this.onUnavailabilityDateChange(input, value)}
          locale="en-US"
          fullWidth={true}

        />
      </div>
      <div className="col-sm-4">
        <Field
          name={`${unavailabilityData}.unavailabilityStartTime`}
          placeholder="Start Time"
          component={renderTimePickerForStaffAvailbility}
          selected={ this.state.unavailabilityData && this.state.unavailabilityData[index] && this.state.unavailabilityData[index].unavailabilityStartTime ? this.state.unavailabilityData[index].unavailabilityStartTime : null}
          disabled ={this.props.unavailabilityData && this.props.unavailabilityData[index] && this.props.unavailabilityData[index].unavailabilityDate ? false : true}
          onDateChange={(input, value) => this.onUnavailabilityDateChange(input, value)}
          fullWidth={true}
        />
      </div>
      <div className="col-sm-4">
        <Field
          name={`${unavailabilityData}.unavailabilityEndTime`}
          placeholder="End Time"
          component={renderTimePickerForStaffAvailbility}
          selected={this.state.unavailabilityData && this.state.unavailabilityData[index] && this.state.unavailabilityData[index].unavailabilityEndTime ? this.state.unavailabilityData[index].unavailabilityEndTime : null}
          disabled ={this.props.unavailabilityData && this.props.unavailabilityData[index] && this.props.unavailabilityData[index].unavailabilityDate ? false : true}
          onDateChange={(input, value) => this.onUnavailabilityDateChange(input, value)}
          fullWidth={true}
        />
      </div>
    </div>);
  }

  handleApplyToAll = () => {
    this.setState({
      applyToAll : !this.state.applyToAll
    });
  }

  renderWeekDays = (week, dayIndex) => {
    dayIndex = dayIndex === undefined ? 0 : dayIndex;
    let weekArr = [{ day: 'Sun' }, { day: 'Mon' }, { day: 'Tue' }, { day: 'Wed' }, { day: 'Thr' }, { day: 'Fri' }, { day: 'Sat' }];
    return weekArr.map((obj, index) => {
      return (

        <li key={index}>
          {dayIndex === 0 ?
            <Field
              name={`isDay[${index}]`}
              label={obj.day}
              component={renderCheckBox}
              onChange={() => this.handleWeekData(index)}
              checked = {this.props.isDay && this.props.isDay[index] ? this.props.isDay[index] : false}
            />
            : ''}
          {this.renderTimes(week, index)}

        </li>
      );

    });
  };

  renderTimes = (week, index) => {
    let slicedWeekIndex = week.slice(5, 6);
    return (
      <div key={index}>

        <div>
          <Field
            name={`${week}[${index}].StartTime`}
            fullWidth={true}
            hintText="Start Time"
            component={renderTimePickerForStaffAvailbility}
            disabled = {this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? false : true}
            selected = { this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? (this.state.week[slicedWeekIndex] && this.state.week[slicedWeekIndex][index] && this.state.week[slicedWeekIndex][index].StartTime ? this.state.week[slicedWeekIndex][index].StartTime : null) : null}
            onDateChange={ (input, value) => this.onTimeChange(input, value, index)}
          />
          <Field
            name={`${week}[${index}].EndTime`}
            fullWidth={true}
            component={renderTimePickerForStaffAvailbility}
            hintText = "End Time"
            disabled = {this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? false : true}
            selected = {this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? (this.state.week[slicedWeekIndex] && this.state.week[slicedWeekIndex][index] && this.state.week[slicedWeekIndex][index].EndTime ? this.state.week[slicedWeekIndex][index].EndTime : null) : null}
            onDateChange={ (input, value) => this.onTimeChange(input, value, index)}

          />
        </div>
      </div>
    );

  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <div className="clearfix"></div>
        <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit)}>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title mt-20">
                <h3>Week Days</h3>
                <span style={{ width: '200px', marginLeft: '50px', fontWeight:'600'}}>
                  <Field
                    name='applyToAll'
                    label='Apply To All'
                    component={renderCheckBox}
                    onChange={() => this.handleApplyToAll()}
                    checked={this.state.applyToAll}
                  />
                </span>
                <i className="flaticon flaticon-calendar"></i>
              </div>
              <div className="weekdayslist">
                <FieldArray name="week" component={this.renderWeekTemplate} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>Availability Date and Time</h3>
                <i className="flaticon flaticon-calendar-1"></i>
              </div>

              <FieldArray name="availabilityData" component={this.renderAvailabilityTemplate} />

            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>Unavailability Date and Time</h3>
                <i className="flaticon flaticon-interface"></i>
              </div>

              <FieldArray name="unavailabilityData" component={this.renderUnavailabilityTemplate} />

            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 pt20 btn_rt">
              {this.props.loading ?
                <CommonButton primary={true} className="loader_btn" disabled = {true } label= "Saving"/> : <CommonButton type="submit" primary={true} label= "Save"/>}
              <CommonButton className="ml_15" primary={true} label ="Submit" onTouchTap={handleSubmit(this.handleSaveAndSubmit)}/>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
const selector = formValueSelector('AvailabilityTemplateForm');
function mapStateToProps(state) {
// console.log('state.user..',selector(state, 'week'))
  let week = [];
  let emptyWeek = [];
  let newWeek = [];
  let isDay = [7];
  for (let i = 0; i < 7; i++) {
    isDay[i] = false;
  }
  let availabilityData = [];
  let unavailabilityData = [];
  let emptyAvailabilityData = new Array(1).fill({ availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null });
  let emptyUnavailabilityData = new Array(1).fill({ unavailabilityDate: null,
    unavailabilityStartTime: null,
    unavailabilityEndTime: null });
  let unavailabilityDate = null;
  let unavailabilityStartTime = null;
  let unavailabilityEndTime = null;
  let availabilityDate = null;
  let availabilityStartTime = null;
  let availabilityEndTime = null;
  for (let i = 0; i < 7; i++) {
    newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
  }
  emptyWeek.push(newWeek);
  function updatefunction(week, index, col, obj) {
    _.update(week, `[${index}][${col}].id`, function(n) {
      return obj.id;
    });
    _.update(week, `[${index}][${col}].DayId`, function(n) {
      return obj.DayId;
    });
    _.update(week, `[${index}][${col}].StartTime`, function(n) {
      return moment(obj.StartTime).format('YYYY-MM-DD') + 'T' + moment(obj.StartTime).format('HH:mm:ss');
    });
    _.update(week, `[${index}][${col}].EndTime`, function(n) {
      return moment(obj.EndTime).format('YYYY-MM-DD') + 'T' + moment(obj.EndTime).format('HH:mm:ss');
    });
  };
  function indexOfLongest(arrays) {
    var longest = -1;
    for (var i = 0; i < arrays.length; i++) {
      if (longest === -1 || arrays[i].length > arrays[longest].length) {
        longest = i;
      }
    }
    return longest;
  };
  function additionalData(week1) {
    let week = week1; // each single entry in multiple of 7
    let monData = [];
    let tueData = [];
    let wedData = [];
    let thrData = [];
    let friData = [];
    let satData = [];
    let sunData = [];

    if (week && week.length > 0) {
      week.map((item, index) => {
        if (!item.length && item.DayId && item.DayId !== undefined) {
          // console.log(item.attributes)
          switch (item.DayId) {
          case state.user.master_data.masterWeekDays[0].id:
            if (sunData.indexOf(item) === -1) {
              return sunData.push(item);
            }
            break;
          case state.user.master_data.masterWeekDays[1].id:
            if (monData.indexOf(item) === -1) {
              return monData.push(item);
            }
            break;
          case state.user.master_data.masterWeekDays[2].id:
            if (tueData.indexOf(item) === -1) {
              return tueData.push(item);
            }
            break;
          case state.user.master_data.masterWeekDays[3].id:
            if (wedData.indexOf(item) === -1) {
              return wedData.push(item);
            }
            break;
          case state.user.master_data.masterWeekDays[4].id:
            if (thrData.indexOf(item) === -1) {
              return thrData.push(item);
            }
            break;
          case state.user.master_data.masterWeekDays[5].id:
            if (friData.indexOf(item) === -1) {
              return friData.push(item);
            }
            break;
          case state.user.master_data.masterWeekDays[6].id:
            if (satData.indexOf(item) === -1) {
              return satData.push(item);
            }
            break;
          default:
            return null;
          }
        } else {
          return false;
        }
        return { monData, tueData, wedData, thrData, friData, satData, sunData };
      });

      let arrays = [monData, tueData, wedData, thrData, friData, satData, sunData];
      let LongestArrayIndex = indexOfLongest(arrays);
      let week2 = new Array(arrays[LongestArrayIndex].length);
      let newWeek = [];
      for (let i = 0; i < week2.length; i++) {
        for (let j = 0; j < 7 ;j++)
          newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
        week2.splice(i, 1, newWeek);
        newWeek = [];
      }
      if (sunData.length > 0) {
        sunData.map((obj, index) => {
          let col = 0;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (monData.length > 0) {
        monData.map((obj, index) => {
          let col = 1;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (tueData.length > 0) {
        tueData.map((obj, index) => {
          let col = 2;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (wedData.length > 0) {
        wedData.map((obj, index) => {
          // console.log('wed data obj', obj)
          let col = 3;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (thrData.length > 0) {
        thrData.map((obj, index) => {
          let col = 4;

          isDay[col] = true;

          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (friData.length > 0) {
        friData.map((obj, index) => {
          let col = 5;

          isDay[col] = true;

          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (satData.length > 0) {
        satData.map((obj, index) => {
          let col = 6;

          isDay[col] = true;

          updatefunction(week2, index, col, obj);
          return true;
        });
      }

      return week2;
    };
  };

  let staffAvailabilityData = null;
  if (state.user.get_availability_template_by_id && state.user.get_availability_template_by_id.data) {
    staffAvailabilityData = state.user.get_availability_template_by_id.data;
    if (staffAvailabilityData.days) {
      staffAvailabilityData.days.map((obj, index) => {
        if (week.indexOf(obj) === -1) {
          week.push({
            id: obj.id,
            DayId: obj.dayId,
            StartTime: obj.startTime,
            EndTime: obj.endTime,
          });
        }
        return { week };
      });
    }

    if (staffAvailabilityData.available) {
      staffAvailabilityData.available.map((obj, index) => {
        if (availabilityData.indexOf(obj) === -1) {
          let id = obj.id;
          availabilityDate = obj.date;
          availabilityStartTime = obj.startTime;
          availabilityEndTime = obj.endTime;

          availabilityData.push({ id: id, availabilityDate: availabilityDate, availabilityStartTime: availabilityStartTime, availabilityEndTime: availabilityEndTime });
        }
        return { availabilityData };
      });
    }
    if (staffAvailabilityData.unavailable) {
      staffAvailabilityData.unavailable.map((obj, index) => {
        if (unavailabilityData.indexOf(obj) === -1) {
          let id = obj.id;
          unavailabilityDate = obj.date;
          unavailabilityStartTime = obj.startTime;
          unavailabilityEndTime = obj.endTime;
          unavailabilityData.push({ id: id, unavailabilityDate: unavailabilityDate, unavailabilityStartTime: unavailabilityStartTime, unavailabilityEndTime: unavailabilityEndTime });
        }
        return { unavailabilityData };
      });
    }
    week = additionalData(week);
  }
  let initialValuesData = {
    week: week === undefined || !week[0] ? emptyWeek : week,
    availabilityData: availabilityData === undefined || !availabilityData[0] ? emptyAvailabilityData : availabilityData,
    unavailabilityData: unavailabilityData === undefined || !unavailabilityData[0] ? emptyUnavailabilityData : unavailabilityData,
    isDay: isDay,

  };

  let staffLocations = null;
  if (state.user.activeUser && state.user.activeUser.staffLocationList) {
    let locations = state.user.activeUser.staffLocationList.map((obj) => obj.id);
    staffLocations = (locations).join(',');
  }
  return {
    saved_master_template: state.user.saved_master_template,
    get_availability_template_by_id: state.user.get_availability_template_by_id,
    saved_availibility_template: state.user.saved_availibility_template,
    master_data: state.user.master_data,
    staffLocations: staffLocations,
    officeHours: state.user.officeHours,
    initialValues: initialValuesData,
    loading: state.user.loading,
    staffAvailabilityData: staffAvailabilityData,
    availabilityData: selector(state, 'availabilityData'),
    unavailabilityData: selector(state, 'unavailabilityData'),
    isDay: selector(state, 'isDay'),
  };
}
AvailabilityTemplate = reduxForm({
  form: 'AvailabilityTemplateForm',
  validate,
  enableReinitialize: true,
})(AvailabilityTemplate);

export default connect(mapStateToProps, { getAvailabilityTemplateByStaffID, getMasterData, saveAvailabilityTemplate })(AvailabilityTemplate);



// WEBPACK FOOTER //
// ./src/modules/users/User/staff_availability_template.js